import { Button, Grid } from "@mui/material";
import { push } from "connected-react-router";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import usePermitGuard from "~/authProvider/usePermitGuard";
import { Content } from "~/components/content/Content";
import { AssembleIssue, SubdataAssembleContextProvider, useSubdataAssembleController } from "~/components/input/useSubdataAssembleController";
import DocumentTypeEditor from "~/components/securefiles/DocumentTypeEditor";
import { MANAGE_FILE_CLASSIFICATION_AND_PROTECTION_RULES } from "~/constants";
import CreateOrEdit from "~/controller/CreateOrEdit";
import { useDefaultSavedHandlers } from "~/controller/defaultSavedHandlers";
import WithSave from "~/controller/WithSave";
import { DocumentTypeInput, DocumentTypeResponseDto } from "~/gen/api/securefile";
import { OdResourcePageProps } from "~/types/resource";
import { useResourceRegister } from "~/utils/resourceRegister";


const CreateDocumentType: FC<OdResourcePageProps> = ({
  options, resource,
}) => {
  useResourceRegister({name: 'secure-files-doc-tmpl-upload'})
  const dispatch = useDispatch()

  usePermitGuard([[MANAGE_FILE_CLASSIFICATION_AND_PROTECTION_RULES]])

  const { assemble, contextValue } = useSubdataAssembleController<{d:DocumentTypeInput}>({ 
    getInformed: (key, value) => {
      // will not get informed
    }
  })
  const handleSave = (save: (record:any,callbacks?:any)=>void) => async () => {
    const result = await assemble()
    
    if (result instanceof AssembleIssue) { return }
    const payload = result.d!

    save(payload, {
      onSuccess: ({data}:{data:DocumentTypeResponseDto}) => {
        dispatch(push(`/${resource}/${data.id}/show`))
      }
    })
  }
  
  const handlers = useDefaultSavedHandlers("Create Document Type")
  
  return (
    <Content 
      pageName="Create Document Type" 
      resourceName="Create" 
      breadcrumbs={[...(options?.breadcrumbs ?? []), 
        { label: 'Document Types', path: `/${resource}` }
      ]}
      mainActions={
        <>
          <CreateOrEdit resource={resource} basePath="" {...handlers}>
            <WithSave 
              render={({save, saving}) =>
                <Button
                  color="primary"
                  disabled={saving}
                  variant="contained"
                  onClick={handleSave(save)}
                >
                  Save
                </Button>}
            />
          </CreateOrEdit>
          <Button
            color="primary"
            variant="outlined"
            component={RouterLink}
            to={`/${resource}`}
          >
            Cancel
          </Button>
        </>
      }
    >
      <Grid container spacing={4} sx={{ mt: 2 }} >
        <Grid item xs={12}>
          <SubdataAssembleContextProvider value={contextValue as any}>
            <DocumentTypeEditor title="New Document Type" />
          </SubdataAssembleContextProvider>
        </Grid>
      </Grid>
    </Content>
  )
}

export default CreateDocumentType;
